import { TipoIdentificacion } from "./tipo-identificacion";

export class Proveedor{
    public constructor(
        public id: String = "",
        public dni: String = "",
        public razon_social:string = "",
        public nombre_comercial:string = "",
        public correo:String = "",
        public telefono:String = "",
        public celular:String = "",
        public direccion:String = "",
        public tipo_dni :String = "",
        public tipo_persona :string = "",
        public actividad_economica_id:String = "",
        public es_obligado: boolean = false,
        public es_contribuyente: boolean = false,
        public num_contribuyente: string = "",
        public empresa_id: String = "",
        public tipo_identificacion_id: number = 0,
        public usuario_id:String = null,


        public tipoidentificacion:TipoIdentificacion = new TipoIdentificacion(),
    ){}

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/proveedor.ts